import styled from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'

const buttonSize = '24px'
const outerMargins = '80px'
const mobileTransition = `calc(50% + ${outerMargins})`
const desktopTransition = `calc(50% + (${buttonSize} / 2) + ${outerMargins})`

export const Button = styled.button`
    cursor: pointer;
    user-select: none;
    position: absolute;
    top: 16px;
    height: ${buttonSize};
    width: ${buttonSize};
    border: 0;

    @media ${respondAbove.md} {
        top: 38px;
    }
    @media ${respondAbove.xl} {
        top: 40px;
    }

    svg {
        display: none;
    }

    &.-prev {
        right: ${mobileTransition};

        @media ${respondAbove.md} {
            right: ${desktopTransition};
        }
    }

    &.-next {
        left: ${mobileTransition};

        @media ${respondAbove.md} {
            left: ${desktopTransition};
        }
    }

    &:focus-visible {
        span {
            outline: 2px solid ${({ theme }) => theme.colors.primary_500};
            border-radius: 4px;
        }
    }
`
